export const stringFilterOperations = [
  "contains",
  "not_contains",
  "equals",
  "not_equals",
  "begins_with",
  "not_begins_with",
  "ends_with",
  "not_ends_with",
] as const;

export const numberFilterOperations = [
  "equals",
  "not_equals",
  "greater_than",
  "greater_than_or_equals",
  "less_than",
  "less_than_or_equals",
  "between",
] as const;

export const dateFilterOperations = ["on_or_before", "on_or_after", "between"] as const;

export type FilterOperation =
  | (typeof stringFilterOperations)[number]
  | (typeof numberFilterOperations)[number]
  | (typeof dateFilterOperations)[number];

export const caseInsensitiveFilterOperations = [
  "contains",
  "not_contains",
  "begins_with",
  "not_begins_with",
  "ends_with",
  "not_ends_with",
] as const;

export interface FilterFormValues {
  operation: FilterOperation;
  values: any[];
}

export type FilterValueType = "text" | "number" | "datetime";

type DateFilter = {
  type: "datetime";
  min?: string;
  max?: string;
};
type StringFilter = {
  type: "text";
};
type NumberFilter = {
  type: "number";
};
export type FilterVariant = (DateFilter | StringFilter | NumberFilter) & {
  type: FilterValueType;
  maxFilterNum?: number;
};

export interface FilterInputGroupProps {
  id?: string;
  variant: FilterVariant;
}

export interface FilterFormProps extends FilterInputGroupProps {
  filterOperations: readonly FilterOperation[];
  onSave: (values: FilterFormValues) => void;
  close: () => void;
}
